/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api/cat_6251
 */

import { message } from 'ant-design-vue'
import {
  col_shopify_batch_get_post,
  col_shopify_detail_page_post,
  col_shopify_export_id_get,
  col_shopify_page_post,
  col_shopify_sync_post
} from 'server/modules/6251'

// 批量查询shopify collection
export const col_shopify_batch_get_post_ = async function(state) {
  let addAsyncDataSource = []
  state.addAsyncDataSource.map(item =>
    addAsyncDataSource.push(item.shopifyCollectionId)
  )
  const { success, data, retInfo } = await col_shopify_batch_get_post({
    ...state.searchParams,
    shopifyCollectionIds: state.unAddQuery.search.split(','),
    existShopifyCollectionIds: addAsyncDataSource
  })
  if (success) {
    state.asyncDataSource = data
  } else {
    message.error(retInfo)
  }
}

// 同步列表
export const col_shopify_detail_page_post_ = async function(state) {
  const { success, data, retInfo } = await col_shopify_detail_page_post({
    ...state.postParams,
    ...state.pagination,
    ...state.searchParams
  })
  if (success) {
    state.dataSource = data.list
    const { pageNum, pageSize, total } = data
    state.pagination = {
      pageNum: pageNum - 0,
      pageSize: pageSize - 0,
      total: total - 0
    }
  } else {
    message.error(retInfo)
  }
}

// 下载同步数据
export const col_shopify_export_id_get_ = async function(params) {
  const { success, data, retInfo } = await col_shopify_export_id_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 同步记录列表
export const col_shopify_page_post_ = async function(state) {
  const { success, data, retInfo } = await col_shopify_page_post({
    ...state.searchParams,
    ...state.logPagination
  })
  if (success) {
    state.logList = data.list
    const { pageNum, pageSize, total } = data
    state.logPagination = {
      pageNum: pageNum - 0,
      pageSize: pageSize - 0,
      total: total - 0
    }
  } else {
    message.error(retInfo)
  }
}

// 同步
export const col_shopify_sync_post_ = async function(params, state) {
  const { success, retInfo } = await col_shopify_sync_post(params)
  if (success) {
    message.success(retInfo)
    state.asyncVisibleChange(0)
  } else {
    message.error(retInfo)
  }
}
